import { render, staticRenderFns } from "./TextRespondModal.vue?vue&type=template&id=0bd89354"
import script from "./TextRespondModal.vue?vue&type=script&lang=js"
export * from "./TextRespondModal.vue?vue&type=script&lang=js"
import style0 from "./TextRespondModal.vue?vue&type=style&index=0&id=0bd89354&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports